import axios from 'axios'
import { SSO_API_BASE_URL, AUTH_ENDPOINTS } from './endpoints'
import { setupAuthInterceptor } from '@/lib/authInterceptor'
import type {
  LoginResponse,
  MeResponse,
  TokenRefreshResponse,
} from './types'

const authAxios = axios.create({
  baseURL: SSO_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

setupAuthInterceptor(authAxios)

export const authAPI = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await authAxios.post(AUTH_ENDPOINTS.login, { email, password })
    return response.data
  },

  refreshToken: async (refresh_token: string): Promise<TokenRefreshResponse> => {
    const response = await authAxios.post(AUTH_ENDPOINTS.refresh, { refresh_token })
    return response.data
  },

  me: async (): Promise<MeResponse> => {
    const response = await authAxios.get(AUTH_ENDPOINTS.me)
    return response.data
  },

  logout: async (): Promise<void> => {
    await authAxios.post(AUTH_ENDPOINTS.logout)
  },

  findUser: async (email: string) => {
    const response = await authAxios.get(AUTH_ENDPOINTS.findUser, { params: { email } })
    return response.data
  },

  getUsers: async (ids: number[]) => {
    const response = await authAxios.post(AUTH_ENDPOINTS.getUsers, { ids })
    return response.data
  },
}
